import { render, staticRenderFns } from "./ShopProductPreview.vue?vue&type=template&id=59501945&scoped=true&"
import script from "./ShopProductPreview.vue?vue&type=script&lang=js&"
export * from "./ShopProductPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductPreview.vue?vue&type=style&index=0&id=59501945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59501945",
  null
  
)

export default component.exports